import Cookies from "js-cookie";
import { create } from "zustand";
import { persist } from "zustand/middleware";

import type { User } from "@/types/user";

import { useContractCartStore } from "./contract-cart";

interface AuthTokens {
	hash?: string;
	accessToken: string;
	refreshToken: string;
}

interface AuthState {
	user: User | null;
	tokens: AuthTokens | null;
	setTokens: (tokens: AuthTokens) => void;
	isAuthenticated: boolean;
	setHash: (hash: string) => void;
	login: (user: User, tokens: AuthTokens) => void;
	updateUser: (user: User) => void;
	logout: () => void;
}

const useAuthStore = create<AuthState>()(
	persist(
		(set, get) => ({
			user: null,
			tokens: null,
			setTokens: (tokens: AuthTokens) => {
				set({ tokens });
			},
			isAuthenticated: false,

			login: (user: User, tokens: AuthTokens) => {
				set({
					user,
					tokens,
					isAuthenticated: true
				});
				Cookies.set("access_token", tokens.accessToken);
				Cookies.set("refresh_token", tokens.refreshToken);
			},

			logout: () => {
				set({
					user: null,
					tokens: null,
					isAuthenticated: false
				});
				useContractCartStore.getState().resetCart();
			},
			setHash: (hash: string) => {
				set(state => ({
					tokens: {
						...state.tokens!,
						hash
					}
				}));
			},
			updateUser: (userData: Partial<User>) => {
				set({ user: { ...get().user!, ...userData } });
			}
		}),
		{
			name: "intasida/auth-storage",
			storage: {
				getItem: (name: string) => {
					const str = localStorage.getItem(name);
					return str ? JSON.parse(str) : null;
				},
				setItem: (name: string, value: unknown) => {
					localStorage.setItem(name, JSON.stringify(value));
				},
				removeItem: (name: string) => {
					localStorage.removeItem(name);
				}
			}
		}
	)
);

export default useAuthStore;
